export default defineNuxtPlugin(() => {
  const { error, success, show } = useToast()
  return {
    provide: {
      toast: {
        apiError: (message: string, e?: any, duration?: number) => {
          const errorMessage = e?.response?.errorData?.message || e?.message
          if (!errorMessage) {
            error(message)
          } else {
            error(message + '\n' + errorMessage, duration)
          }
        },
        error,
        success,
        show,
      },
    },
  }
})
